<template>

    <div class="d-flex w-100 align-items-center">
        <div class="col-md-3 px-0">
            <!-- <checkbox name="allotment" class="" v-model="bulkObject.deliverNotification" value="1" v-if="showDeliverNotification">Deliver notification</checkbox> -->
        </div>
        <div class="col-md-9 text-right">
            <button class="btn tertiary px-5" @click="cancelEdit">Close</button>
            <!-- <button class="btn tertiary px-5" @click="cancelEdit">Cancel</button>
            <button class="btn success px-5" @click="submitBulk">Save</button> -->
        </div>
    </div>

</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import {eventHub} from '../../../main'

    export default {
        props: {
            activeArea: {
                type: String,
            },
            bulkObject: {
                type: Object
            }
        },
        data: function() {
            return {
                deliverNotification: true
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedEvent',
                'account',
                'isCreatingSingleEvent'
            ]),
            showDeliverNotification: function() {
                return this.activeArea != 'areaTickets'
            }
        },
        methods: {
            ...mapActions([
                'saveEventChanges',
                'closeModal',
                'setModalConfirmData',
                'openModal',
                'flushEvents',
                'setReservationSelectedEvent',
                'setReservationSelectedProduct',
            ]),
            submitBulk: function(){
                this.$emit('submitBulk')
            },
            cancelEdit: function() {
                this.$emit('cancelEdit');
            }

        },
        components: {
        }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// footerButtons.vue?89c6e488